import React from 'react';
import { Container, Stack, Title, Text, List, ThemeIcon, Group } from '@mantine/core';
import { IconCheck, IconTarget, IconBulb } from '@tabler/icons-react';

const About = () => {
  const features = [
    'Search wilderness areas by location and activity',
    'Detailed information about trails, camping, and regulations',
    'Weather information and safety tips',
    'Community reviews and recommendations',
    'Adventure planning tools'
  ];

  return (
    <Container size="md">
      <Stack gap="xl">
        <Stack gap="md">
          <Title order={1} c="green">About WildernessFinder</Title>
          <Text size="lg" c="dimmed">
            WildernessFinder is a comprehensive platform designed to help outdoor enthusiasts 
            discover, explore, and share information about wilderness areas in North America.
          </Text>
        </Stack>
        
        <Stack gap="md">
          <Group gap="sm">
            <IconTarget size={24} color="var(--mantine-color-green-6)" />
            <Title order={2} c="green">Our Mission</Title>
          </Group>
          <Text>
            To connect people with nature by providing easy access to wilderness information, 
            helping them plan safe and enjoyable outdoor adventures.
          </Text>
        </Stack>
        
        <Stack gap="md">
          <Group gap="sm">
            <IconBulb size={24} color="var(--mantine-color-green-6)" />
            <Title order={2} c="green">Features</Title>
          </Group>
          <List
            spacing="sm"
            size="sm"
            center
            icon={
              <ThemeIcon color="green" size={20} radius="xl">
                <IconCheck size={12} />
              </ThemeIcon>
            }
          >
            {features.map((feature, index) => (
              <List.Item key={index}>{feature}</List.Item>
            ))}
          </List>
        </Stack>
      </Stack>
    </Container>
  );
};

export default About;
